/* eslint-disable rulesdir/imports */
/* eslint-disable monorepo/no-internal-import */
import ActionBarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ActionBar.svg';
import ActionButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ActionButton.svg';
import ActionGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ActionGroup.svg';
import AdobeDefaultSvg from '@react-spectrum/docs/pages/assets/component-illustrations/AdobeDefault.svg';
import AutocompleteSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Autocomplete.svg';
import AvatarGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/AvatarGroup.svg';
import AvatarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Avatar.svg';
import BadgeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Badge.svg';
import BreadcrumbsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Breadcrumbs.svg';
import ButtonGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ButtonGroup.svg';
import ButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Button.svg';
import CalendarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Calendar.svg';
import {Card, CardPreview, CardProps, Content, Text} from '@react-spectrum/s2';
import CardSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Card.svg';
import CardViewSvg from '@react-spectrum/docs/pages/assets/component-illustrations/CardView.svg';
import CheckboxGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/CheckboxGroup.svg';
import CheckboxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Checkbox.svg';
import CollectionsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Collections.svg';
import ColorAreaSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorArea.svg';
import ColorFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorField.svg';
import ColorPickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorPicker.svg';
import ColorSliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSlider.svg';
import ColorSwatchPickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatchPicker.svg';
import ColorSwatchSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorSwatch.svg';
import ColorWheelSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ColorWheel.svg';
import ComboBoxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ComboBox.svg';
import ContextualHelpSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ContextualHelp.svg';
import DateFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DateField.svg';
import DatePickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DatePicker.svg';
import DateRangePickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DateRangePicker.svg';
import DialogSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Dialog.svg';
import DisclosureGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DisclosureGroup.svg';
import DisclosureSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Disclosure.svg';
import DividerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Divider.svg';
import DragAndDropSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DragAndDrop.svg';
import DropZoneSvg from '@react-spectrum/docs/pages/assets/component-illustrations/DropZone.svg';
import {ExampleImage} from './ExampleList';
import FileTriggerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/FileTrigger.svg';
import FocusScopeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/FocusScope.svg';
import FormSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Form.svg';
import GroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Group.svg';
import IconsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Icons.svg';
import IllustratedMessageSvg from '@react-spectrum/docs/pages/assets/component-illustrations/IllustratedMessage.svg';
import IllustrationsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Illustrations.svg';
import ImageSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Image.svg';
import InlineAlertSvg from '@react-spectrum/docs/pages/assets/component-illustrations/InlineAlert.svg';
import InputSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Input.svg';
import InternationalizedDateSvg from '@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDate.svg';
import InternationalizedDefaultSvg from '@react-spectrum/docs/pages/assets/component-illustrations/InternationalizedDefault.svg';
import LabeledValueSvg from '@react-spectrum/docs/pages/assets/component-illustrations/LabeledValue.svg';
import LabelSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Label.svg';
import LinkSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Link.svg';
import ListBoxSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ListBox.svg';
import ListViewSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ListView.svg';
import mcpSvg from './icons/mcp.svg';
import MenuSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Menu.svg';
import MeterSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Meter.svg';
import ModalSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Modal.svg';
import NumberFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/NumberField.svg';
import {Page} from '@parcel/rsc';
import PickerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Picker.svg';
import PopoverSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Popover.svg';
import ProgressBarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ProgressBar.svg';
import ProgressCircleSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ProgressCircle.svg';
import RadioGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RadioGroup.svg';
import RangeCalendarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RangeCalendar.svg';
import RangeSliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/RangeSlider.svg';
import React from 'react';
import ReactAriaDefaultSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ReactAriaDefault.svg';
import SearchFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/SearchField.svg';
import SegmentedControlSvg from '@react-spectrum/docs/pages/assets/component-illustrations/SegmentedControl.svg';
import SelectBoxGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/SelectBoxGroup.svg';
import SelectionSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Selection.svg';
import SkeletonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Skeleton.svg';
import SliderSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Slider.svg';
import StatusLightSvg from '@react-spectrum/docs/pages/assets/component-illustrations/StatusLight.svg';
import {style} from '@react-spectrum/s2/style' with { type: 'macro' };
import SwitchSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Switch.svg';
import TableSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Table.svg';
import TabsSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tabs.svg';
import TagGroupSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TagGroup.svg';
import TextAreaSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TextArea.svg';
import TextFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TextField.svg';
import TimeFieldSvg from '@react-spectrum/docs/pages/assets/component-illustrations/TimeField.svg';
import ToastSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Toast.svg';
import ToggleButtonSvg from '@react-spectrum/docs/pages/assets/component-illustrations/ToggleButton.svg';
import ToolbarSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Toolbar.svg';
import TooltipSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tooltip.svg';
import TreeSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Tree.svg';
import useFocusRingSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocusRing.svg';
import useFocusSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocus.svg';
import useFocusWithinSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useFocusWithin.svg';
import useHoverSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useHover.svg';
import useKeyboardSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useKeyboard.svg';
import useLongPressSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useLongPress.svg';
import useMoveSvg from '@react-spectrum/docs/pages/assets/component-illustrations/useMove.svg';
import usePressSvg from '@react-spectrum/docs/pages/assets/component-illustrations/usePress.svg';
import VirtualizerSvg from '@react-spectrum/docs/pages/assets/component-illustrations/Virtualizer.svg';

export interface ComponentCardItem {
  id: string,
  name: string,
  href: string
}

const componentIllustrations: Record<string, React.ComponentType | undefined> = {
  'Accordion': DisclosureGroupSvg,
  'ActionBar': ActionBarSvg,
  'ActionButton': ActionButtonSvg,
  'ActionButtonGroup': ButtonGroupSvg, // TODO: get better illustration
  'ActionGroup': ActionGroupSvg,
  'ActionMenu': MenuSvg,
  'Autocomplete': AutocompleteSvg,
  'Avatar': AvatarSvg,
  'AvatarGroup': AvatarGroupSvg,
  'Badge': BadgeSvg,
  'Breadcrumbs': BreadcrumbsSvg,
  'Button': ButtonSvg,
  'ButtonGroup': ButtonGroupSvg,
  'Calendar': CalendarSvg,
  'Card': CardSvg,
  'CardView': CardViewSvg,
  'Checkbox': CheckboxSvg,
  'CheckboxGroup': CheckboxGroupSvg,
  'Collections': CollectionsSvg,
  'ColorArea': ColorAreaSvg,
  'ColorField': ColorFieldSvg,
  'ColorPicker': ColorPickerSvg,
  'ColorSlider': ColorSliderSvg,
  'ColorSwatch': ColorSwatchSvg,
  'ColorSwatchPicker': ColorSwatchPickerSvg,
  'ColorWheel': ColorWheelSvg,
  'ComboBox': ComboBoxSvg,
  'ContextualHelp': ContextualHelpSvg,
  'DateField': DateFieldSvg,
  'DatePicker': DatePickerSvg,
  'DateRangePicker': DateRangePickerSvg,
  'Dialog': DialogSvg,
  'Disclosure': DisclosureSvg,
  'DisclosureGroup': DisclosureGroupSvg,
  'Divider': DividerSvg,
  'Drag and Drop': DragAndDropSvg,
  'DropZone': DropZoneSvg,
  'FileTrigger': FileTriggerSvg,
  'FocusScope': FocusScopeSvg,
  'Form': FormSvg,
  'GridList': ListViewSvg, // GridList -> ListView
  'Group': GroupSvg,
  'Icons': IconsSvg,
  'IllustratedMessage': IllustratedMessageSvg,
  'Illustrations': IllustrationsSvg,
  'Image': ImageSvg,
  'InlineAlert': InlineAlertSvg,
  'Input': InputSvg,
  'InternationalizedDate': InternationalizedDateSvg,
  'Label': LabelSvg,
  'LabeledValue': LabeledValueSvg,
  'Link': LinkSvg,
  'LinkButton': ButtonSvg, // TODO: get better illustration
  'ListBox': ListBoxSvg,
  'ListView': ListViewSvg,
  'Menu': MenuSvg,
  'Meter': MeterSvg,
  'Modal': ModalSvg,
  'NumberField': NumberFieldSvg,
  'Picker': PickerSvg,
  'Popover': PopoverSvg,
  'ProgressBar': ProgressBarSvg,
  'ProgressCircle': ProgressCircleSvg,
  'RadioGroup': RadioGroupSvg,
  'RangeCalendar': RangeCalendarSvg,
  'RangeSlider': RangeSliderSvg,
  'SearchField': SearchFieldSvg,
  'SegmentedControl': SegmentedControlSvg,
  'Select': PickerSvg, // Select -> Picker
  'SelectBoxGroup': SelectBoxGroupSvg,
  'Selection': SelectionSvg,
  'Skeleton': SkeletonSvg,
  'Slider': SliderSvg,
  'StatusLight': StatusLightSvg,
  'Switch': SwitchSvg,
  'Table': TableSvg,
  'TableView': TableSvg,
  'Tabs': TabsSvg,
  'TagGroup': TagGroupSvg,
  'TextArea': TextAreaSvg,
  'TextField': TextFieldSvg,
  'TimeField': TimeFieldSvg,
  'Toast': ToastSvg,
  'ToggleButton': ToggleButtonSvg,
  'ToggleButtonGroup': ActionGroupSvg, // ToggleButtonGroup -> ActionGroup
  'Toolbar': ToolbarSvg,
  'Tooltip': TooltipSvg,
  'Tree': TreeSvg,
  'TreeView': TreeSvg,
  'Virtualizer': VirtualizerSvg,
  'useFocus': useFocusSvg,
  'useFocusRing': useFocusRingSvg,
  'useFocusWithin': useFocusWithinSvg,
  'useHover': useHoverSvg,
  'useKeyboard': useKeyboardSvg,
  'useLongPress': useLongPressSvg,
  'useMove': useMoveSvg,
  'usePress': usePressSvg,
  'MCP Server': mcpSvg
};

// Overrides for specific illustrations so they fit within the cards.
const propOverrides: Record<string, any> = {
  Autocomplete: {
    style: {height: 'calc(100% - 16px)'}
  },
  DateField: {
    viewBox: '0 -56 276 276'
  },
  TimeField: {
    viewBox: '0 -56 276 276'
  },
  DatePicker: {
    style: {alignSelf: 'end', height: 'calc(100% - 16px)'}
  },
  DateRangePicker: {
    style: {alignSelf: 'end', height: 'calc(100% - 16px)'}
  },
  DropZone: {
    viewBox: '0 0 290 220',
    style: {height: 'calc(100% - 16px)'}
  },
  Select: {
    // Safari doesn't calculate the max-height correctly with the aspect-ratio.
    style: {height: 'calc(100% - 16px)'}
  },
  Picker: {
    style: {height: 'calc(100% - 16px)'}
  },
  ComboBox: {
    style: {height: 'calc(100% - 16px)'}
  }
};

const illustrationContainer = style({
  width: 'full',
  aspectRatio: '3/2',
  backgroundColor: '--anatomy-gray-100',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 0
});

const illustrationStyles = style({
  maxWidth: 'calc(100% - 16px)',
  userSelect: 'none',
  pointerEvents: 'none'
});

function getDefaultIllustration(href: string) {
  if (href.includes('/react-aria/')) {
    return ReactAriaDefaultSvg;
  } else if (href.includes('/internationalized/')) {
    return InternationalizedDefaultSvg;
  }
  return AdobeDefaultSvg;
}

interface ComponentCardProps extends Omit<CardProps, 'children'> {
  name: string,
  href: string,
  description?: string
}

export function ComponentCard({id, name, href, description, size, ...otherProps}: ComponentCardProps) {
  let IllustrationComponent = componentIllustrations[name] || getDefaultIllustration(href);
  let overrides = propOverrides[name] || {};
  let preview;
  if (href.includes('react-aria/examples/') && !href.endsWith('index.html')) {
    preview = <ExampleImage name={href} />;
  } else {
    preview = (
      <div className={illustrationContainer}>
        <IllustrationComponent
          {...overrides}
          aria-hidden="true"
          // @ts-ignore
          className={illustrationStyles}
          style={{
            maxHeight: 'calc(100% - 16px)',
            ...overrides.style
          }} />
      </div>
    );
  }

  return (
    <Card {...otherProps} id={id} href={href} size={size} textValue={name}>
      <CardPreview>
        {preview}
      </CardPreview>
      <Content>
        <Text slot="title">{name}</Text>
        {description && <Text slot="description">{description}</Text>}
      </Content>
    </Card>
  );
}

interface ComponentListProps {
  pages: Page[],
  components: string[]
}

export function ComponentList(props: ComponentListProps) {
  let pages = props.pages.filter(page => props.components.includes(page.name));
  return (
    <ul
      className={style({
        display: 'flex',
        gap: 24,
        listStyleType: 'none',
        overflow: 'auto',
        '--paddingX': {
          type: 'paddingStart',
          value: {
            default: 12,
            lg: 40
          }
        },
        paddingX: '--paddingX',
        marginX: {
          default: -12,
          lg: -40
        },
        paddingY: 20,
        marginY: -20,
        scrollSnapType: 'x',
        scrollPaddingX: '--paddingX'
      })}
      style={{
        maskImage: 'linear-gradient(to right, transparent, white var(--paddingX) calc(100% - var(--paddingX)), transparent)'
      }}>
      {pages.map(page => (
        <li key={page.url}>
          <ComponentCard name={getTitle(page)} href={page.url} size="S" UNSAFE_style={{scrollSnapAlign: 'start'}} />
        </li>
      ))}
    </ul>
  );
}

const getTitle = (page: Page) => page.tableOfContents?.[0]?.title ?? '';
